import React from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import FooterNav from "../FooterNav";
import { ROUTES } from "../shared/constants/routes";
import ScreenComponent from "../components/ScreenComponent";
import Header from "../Header";
import { FOOTER_HEIGHT } from "../shared/constants/dimension";
import AppLoader from "../components/AppLoader";
import { ModalType, useModalStore } from "../store/modalStore";
import { usePlatform } from "../providers/PlatformProvider";
import { PaperProvider } from "react-native-paper";
import { useThemeSettings } from "../ThemeProvider";
import WelcomeScreen from "../features/onBoarding/screen/WelcomeScreen";
import { useTourStore } from "../store/useTourStore";


const Tab = createBottomTabNavigator();

export default function TabNavigator() {
  const nonFooterScreen = [
    ROUTES.WELCOME,
    ROUTES.WELCOME_ONBOARDING,
    ROUTES.WEB,
    ROUTES.RECOMMENDED_COLLECTIONS
  ] as string[];
  const { showWebVersion } = usePlatform();
  const { modalShown } = useModalStore();
  const { theme } = useThemeSettings();
  const shouldShowOnboarding = useTourStore((s) => s.shouldShowOnboarding());
  return (

    <PaperProvider theme={theme}>
      {showWebVersion && <Header />}
        <Tab.Navigator
        initialRouteName={
          shouldShowOnboarding ? ROUTES.WELCOME_ONBOARDING : ROUTES.HOME
        }
        backBehavior="history"
        screenOptions={{
          headerShown: false,
          tabBarStyle: { height: FOOTER_HEIGHT, backgroundColor: "transparent" },
        }}
        tabBar={(props) => {
          if (!showWebVersion && modalShown === ModalType.NONE) {
            const currentRoute = props.state.routes[props.state.index].name;
            if (nonFooterScreen.includes(currentRoute)) {
              return null;
            }
            return <FooterNav {...props} />;
          } else {
            return null;
          }
        }}
      >
        <Tab.Screen
          name={ROUTES.WELCOME_ONBOARDING}
          component={WelcomeScreen}
        />
        <Tab.Screen name={ROUTES.HOME} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.IMMERSRSIVE_NEWS_ARTICLE} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.LOGIN} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.SETTINGS} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.FAQ} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.TERMS} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.PRIVACY} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.CONTACT_US} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.CREATE_COLLECTION} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.EDIT_COLLECTION} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.RECOMMENDED_COLLECTIONS} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.RADIO_PLAYER} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.TBD} component={ScreenComponent} />
        <Tab.Screen name={ROUTES.WELCOME} component={AppLoader} />
      </Tab.Navigator>
    </PaperProvider>
  );
}
